import React from 'react';
import PropTypes from 'prop-types';
import {Subheader, Paper} from 'material-ui';
import style from '../../../../styles/styles';
import Info from "../../../common/Info/Info";

const Timestamp = require('react-timestamp');

class ReportSubjectInfo extends React.Component {
    static propTypes = {
        subject: PropTypes.object.isRequired
    };

    render() {
        return (
            <Paper>
                <Subheader style={style.subHeader}>Information</Subheader>
                <div style={style.paper}>
                    <Info
                        title="Id"
                        content={this.props.subject.id}
                    />
                    <Info
                        title="Name"
                        content={this.props.subject.name}
                    />
                    <Info
                        title="Color"
                        content={this.props.subject.color}
                    />
                    <Info
                        title="Display order"
                        content={this.props.subject.display_order}
                    />
                    <Info
                        title="Created at"
                        content={<Timestamp time={this.props.subject.created_at} format='full' twentyFourHour/>}
                    />
                    <Info
                        title="Updated at"
                        content={(
                            this.props.subject.updated_at &&
                            <Timestamp time={this.props.subject.updated_at} format='full' twentyFourHour/>
                        ) || 'Has never been updated'}
                        divider={false}
                    />
                </div>
            </Paper>
        )
    };
}

export default ReportSubjectInfo;



// WEBPACK FOOTER //
// src/components/report/ReportSubjectFull/ReportSubjectInfo/ReportSubjectInfo.js